import { createFeatureSelector, createSelector } from '@ngrx/store'
import { OfficeState } from './office.reducer'

export const selectOfficeState = createFeatureSelector<OfficeState>('office')

export const selectOfficeId = createSelector(selectOfficeState, (state: OfficeState) =>
  state.offices.length > 0 ? state.offices[state.offices.length - 1].id : null
)
